import React, { createRef } from 'react';
import { connect } from 'react-redux';
// import { push } from 'react-router-redux';
import { Link } from 'react-router-dom';
// import PropTypes from 'prop-types';

// react leaflet
import {
  // Circle,
  // FeatureGroup,
  // LayerGroup,
  Map as LeafletMap,
  TileLayer,
  Marker,
  Popup,
  // Tooltip,
  GeoJSON,
  // Rectangle
} from 'react-leaflet';
import L from 'leaflet';

// Components
import MapToggle from 'components/_shared/ArsMap/MapToggle/MapToggle';

// SVGs
// import Sisu from 'images/sisu.png';
import pin from 'svgs/pin.svg';
import blackpin from 'svgs/black-pin.svg';
// Constants
import { organizationLogos } from '../../../constants/constants';
// Styles
import './ArsMap.css';

// import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

const DefaultIcon = L.icon({
    iconUrl: pin,
    shadowUrl: iconShadow
});


const blackIcon = L.icon({
  iconUrl: blackpin,
  shadowUrl: iconShadow
})

L.Marker.prototype.options.icon = DefaultIcon;

// const providerImages = {
//   sisu: Sisu
// };

export class ArsMap extends React.Component {
  // Prop Types
  // ------------------------------------------------------------------------ //
  static propTypes = {};
  static defaultProps = {};

  // Constructor
  // ------------------------------------------------------------------------ //

  // Variables
  // ------------------------------------------------------------------------ //
  markerRef = createRef()
  mapRef = createRef()

  // Lifecycle methods
  // ------------------------------------------------------------------------ //
  componentDidMount() {
    this.getInitLocation();
  }

  // Event handlers
  // ------------------------------------------------------------------------ //
  handleClick = e => {
    const { lat, lng } = e.latlng;
    this.props.setLocation({ lat, lng});
  }

  handleMarker = marker => {
    this.setAllIcons(DefaultIcon)
    marker.target.setIcon(blackIcon)
  } 

  // Class methods
  // ------------------------------------------------------------------------ //
  setAllIcons = icon => {
    this.mapRef.current.leafletElement.eachLayer(layer => {
      if (typeof layer.setIcon === 'function') {
        layer.setIcon(icon)
      }
    })
  }

  getInitLocation = () => {
    if ("geolocation" in navigator) {
      /* geolocation is available */
      navigator.geolocation.getCurrentPosition(
        position => this.props.setLocation({ lat: position.coords.latitude, lng: position.coords.longitude}),
        err => console.log('geolocation error', err)
      );
    } else {
      console.log('No geolocation available')
      /* geolocation IS NOT available */
      return;
    }
  }

  navToOrgDetails = (e, org) => {
    if (e) e.preventDefault();
    // this.props.dispatch(push(`/details/${org}`))
  }

  // Render methods
  // ------------------------------------------------------------------------ //
  createMarkers = () => {
    return this.props.providers.map(provider => {
      let contactsLen = provider.contact.length;
      let timestamp = Date.parse(provider.timestamp);
      let orgLogo = organizationLogos.find(
        lgo => provider.organization.toLowerCase().trim().replace(/ /g, '_') === lgo.split('/')[3].split('.')[0]
      )
      return provider.contact.map((location, idx) => {
        return location.address && location.geoPosition ? (
          <Marker
            key={`${timestamp}_${idx}_marker`}
            position={[
              location.geoPosition.lat,
              location.geoPosition.lng
            ]}

            ref={this.props.currentProvider && this.props.currentProvider === `${timestamp}_${idx}` ? this.markerRef : null}
            onClick={this.handleMarker}
          >
            <Popup>
              <div className="provider-popup__container">
                {orgLogo ?
                  <div className="provider__image"><img src={orgLogo} alt="organization popup"/></div> : null}
                <div className={`provider-popup`}>
                  <Link className={`provider-popup__title`} to={`/details/${provider.organization}`}>{`${provider.organization}${contactsLen > 1 ? (` - ${location.title || location.city.slice(-5)}`) : ''}`}</Link>
                  <p className={`provider-popup__address`}>{location.address}</p>
                  <p className={`provider-popup__city`}>{location.city}</p>
                  <p className={`provider-popup__phone`}>{location.telephone}</p>
                  <div className={`provider-popup__sites`}>
                    { provider.information && provider.information.map(
                      ({site}) => (
                    <a 
                      key={`${Date.parse(provider.timestamp)}_${idx}_anchor`}
                      target="_blank"
                      href={`${site}`}
                      className={`provider-popup__site`}>{site}</a>
                      )
                    )}
                  </div>
                  <div className={`provider-popup__details`}>
                    <Link to={`/details/${provider.organization}`} className={`provider-popup__site`}>See Details</Link>
                  </div>
                </div>
              </div>
            </Popup>
          </Marker>
        ) : null}
      )
    })
  }


  render() {
    const overlay = Object.keys(this.props.overlay).find(key => {
      return this.props.overlay[key];
    })

    // for showing popup of clicked org in directory list
    if (this.markerRef.current) {
      this.setAllIcons(DefaultIcon)
      this.markerRef.current.leafletElement.openPopup()
      this.markerRef.current.leafletElement.setIcon(blackIcon)
    }

    return (
      <div className={`
        arsmap
        ${this.props.fullSize ? "arsmap--full" : ""}
        `}>
        <LeafletMap
          center={this.props.location}
          zoom={this.props.zoom}
          ref={this.mapRef}
          onClick={this.handleClick}
          >
          <TileLayer
            attribution='&copy; <a target="_blank" href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a target="_blank" href="https://carto.com/attribution">CARTO</a>'
            url='https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'
          />
          <MapToggle
            switchMapView={this.props.handleMapView}
            mapView={this.props.fullSize}
          />
          {this.props.providers.length > 0 && this.createMarkers()}
          {overlay ?
              (
                this.props.geoData[overlay + '_data'].features.map(feature => {
                  // onClick={e => console.log('geojson click', e)}
                  return (
                  <GeoJSON
                    data={feature}
                    style={feature.properties.style || null}
                  />
                )})
              )
            : 
              null
          }
        </LeafletMap>
      </div>
    );
  }
}

// <GeoJSON
//   data={geoData[overlay + '_data']} 
//   onClick={e => console.log('geojson click', e)}
// />)}
export default connect(null)(ArsMap);



// WEBPACK FOOTER //
// ./src/components/_shared/ArsMap/ArsMap.js